function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 7.49935C2.5 7.03911 2.8731 6.66602 3.33333 6.66602H16.6667C17.1269 6.66602 17.5 7.03911 17.5 7.49935C17.5 7.95959 17.1269 8.33268 16.6667 8.33268H3.33333C2.8731 8.33268 2.5 7.95959 2.5 7.49935Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 12.4993C2.5 12.0391 2.8731 11.666 3.33333 11.666H16.6667C17.1269 11.666 17.5 12.0391 17.5 12.4993C17.5 12.9596 17.1269 13.3327 16.6667 13.3327H3.33333C2.8731 13.3327 2.5 12.9596 2.5 12.4993Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.42608 1.67119C8.88351 1.72201 9.21312 2.13403 9.16229 2.59145L7.49563 17.5914C7.4448 18.0489 7.03279 18.3785 6.57536 18.3277C6.11794 18.2768 5.78833 17.8648 5.83915 17.4074L7.50582 2.4074C7.55665 1.94997 7.96866 1.62036 8.42608 1.67119Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4261 1.67119C13.8835 1.72201 14.2131 2.13403 14.1623 2.59145L12.4956 17.5914C12.4448 18.0489 12.0328 18.3785 11.5754 18.3277C11.1179 18.2768 10.7883 17.8648 10.8392 17.4074L12.5058 2.4074C12.5566 1.94997 12.9687 1.62036 13.4261 1.67119Z",
  fill: "white"
});

var SvgHash = function SvgHash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hash.1937c503.svg";
export { ForwardRef as ReactComponent };